export const environment = {
  isStaticCloud() {
    return (
      window.location.host === 'auto-refi-sb.clouddqt.capitalone.com' ||
      window.location.host === 'auto-refi-perf.clouddqt.capitalone.com' ||
      window.location.host === 'auto-refi-dev.clouddqt.capitalone.com' ||
      window.location.host === 'auto-refi-qa.clouddqt.capitalone.com'
    );
  },
  getBaseUrl() {
    switch (window.location.host) {
      case 'coaf-lienholder-mfe.cloud.capitalone.com':
        return 'https://api.capitalone.com';
      case 'coaf-lienholder-mfe-qa.clouddqtext.capitalone.com':
        return 'https://api-it.capitalone.com';
      case 'coaf-lienholder-mfe-dev.clouddqtext.capitalone.com':
        return 'https://fs-lienholder-bff-dev.clouddqt.capitalone.com';
      case 'coaf-lienholder-mfe-sb.clouddqtext.capitalone.com':
        return 'https://fs-lienholder-bff-sb.clouddqt.capitalone.com';
      case 'coaf-lienholder-mfe-perf.clouddqtext.capitalone.com':
        return 'https://api-it.capitalone.com';
      default:
        return 'https://api-it.capitalone.com';
    }
  },
  get isProdEnv() {
    return ['autorefi.capitalone.com', 'coaf-refi-web-ui.capitalone.com', 'coaf-lienholder-mfe.capitalone.com'].includes(window.location.hostname);
  },
};
